import { useParams } from "react-router";
import { DocumentationCard } from "@/services/backend/vbs/work-orders/components/documentation-card";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";

export function WorkOrderCompletionDocumentationRoute() {
  const { workOrderId, documentationId } = useParams();
  const { data: workOrder } = useVbsWorkOrderShowQuery({ id: workOrderId! });
  return (
    <DocumentationCard
      documentationId={documentationId!}
      workOrderId={workOrderId!}
      disabled={workOrder?.immutable ?? false}
    />
  );
}
